import { TextButtonCellRenderer, type TypeTextButtonCellRendererProps } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import styles from './TableCellRenderer.module.scss';

export type TypeTextButtonCellProps = Omit<TypeTextButtonCellRendererProps, 'size'> & {
  /** 셀 값. showDashIfNoValue 가 켜져 있으면 값이 비었을 때 버튼 대신 '-' 를 보인다. */
  value?: unknown;
  /** @default true */
  showDashIfNoValue?: boolean;
};

const isEmptyValue = (value: unknown): boolean => !value || (Array.isArray(value) && value.length === 0);

/**
 * 표 셀용 TextButton. kitchen TextButtonCellRenderer 에 기존 표의 모양(밑줄·semi-bold·칸 왼쪽 정렬)과
 * 빈 값 '-' 표시를 더한다.
 */
const TextButtonCell = ({
  value,
  showDashIfNoValue = true,
  variant = 'underline',
  weight = 'semi-bold',
  className,
  ...props
}: TypeTextButtonCellProps) => {
  if (showDashIfNoValue && isEmptyValue(value)) return <>-</>;

  return (
    <TextButtonCellRenderer
      className={clsx(styles['text-button-cell'], className)}
      variant={variant}
      weight={weight}
      {...props}
    />
  );
};

export default TextButtonCell;
